var map = {
	"./a_analitico": 80,
	"./a_analitico.png": 80,
	"./a_estrategico": 81,
	"./a_estrategico.png": 81,
	"./account": 82,
	"./account.svg": 82,
	"./anagrama": 83,
	"./anagrama-tirant": 84,
	"./anagrama-tirant.svg": 84,
	"./anagrama.svg": 83,
	"./anagrama_tirant_blanco": 71,
	"./anagrama_tirant_blanco.png": 71,
	"./analytics/analytics_peq": 85,
	"./analytics/analytics_peq.png": 85,
	"./analytics/bghead": 86,
	"./analytics/bghead.png": 86,
	"./arg/bghead": 87,
	"./arg/bghead.png": 87,
	"./bg-circle": 88,
	"./bg-circle-front": 89,
	"./bg-circle-front.png": 89,
	"./bg-circle.png": 88,
	"./bin-card/icoAi": 72,
	"./bin-card/icoAi.png": 72,
	"./bol/bghead": 90,
	"./bol/bghead.png": 90,
	"./bra/bghead": 91,
	"./bra/bghead.png": 91,
	"./calculos_laborales_bg": 92,
	"./calculos_laborales_bg.png": 92,
	"./calculos_laborales_ico": 93,
	"./calculos_laborales_ico.png": 93,
	"./cgae/bannerheader": 94,
	"./cgae/bannerheader.png": 94,
	"./cgae/bghead": 95,
	"./cgae/bghead.png": 95,
	"./cgae/rlogo": 96,
	"./cgae/rlogo.png": 96,
	"./chl/bghead": 97,
	"./chl/bghead.png": 97,
	"./chl/favicon.ico": 542,
	"./chl/ico_biblioteca": 98,
	"./chl/ico_biblioteca.svg": 98,
	"./chl/ico_consultoria": 99,
	"./chl/ico_consultoria.svg": 99,
	"./col/bghead": 100,
	"./col/bghead.png": 100,
	"./col/favicon.ico": 543,
	"./common/anfix": 101,
	"./common/anfix.svg": 101,
	"./common/bell": 102,
	"./common/bell.svg": 102,
	"./common/calendar_leads": 103,
	"./common/calendar_leads.png": 103,
	"./common/news": 104,
	"./common/news-solid": 105,
	"./common/news-solid.svg": 105,
	"./common/news.svg": 104,
	"./common/newspaper": 106,
	"./common/newspaper.svg": 106,
	"./common/notes": 107,
	"./common/notes.svg": 107,
	"./common/save": 108,
	"./common/save.svg": 108,
	"./common/sofia": 109,
	"./common/sofia.svg": 109,
	"./common/sofia30_mono": 73,
	"./common/sofia30_mono.svg": 73,
	"./common/user": 110,
	"./common/user.svg": 110,
	"./conmex/analytics": 111,
	"./conmex/analytics.png": 111,
	"./conmex/bghead": 112,
	"./conmex/bghead.png": 112,
	"./conmex/biblioteca": 113,
	"./conmex/biblioteca.png": 113,
	"./conmex/calculator": 114,
	"./conmex/calculator.png": 114,
	"./conmex/consultoria": 115,
	"./conmex/consultoria.png": 115,
	"./conmex/gacetas": 116,
	"./conmex/gacetas.png": 116,
	"./conmex/gestion": 117,
	"./conmex/gestion.png": 117,
	"./conmex/herramientas": 118,
	"./conmex/herramientas.png": 118,
	"./conmex/legislacion": 119,
	"./conmex/legislacion.png": 119,
	"./conmex/novedades": 120,
	"./conmex/novedades.png": 120,
	"./conmex/peticiones": 121,
	"./conmex/peticiones.png": 121,
	"./conmex/rfcs": 122,
	"./conmex/rfcs.png": 122,
	"./conmex/temas": 123,
	"./conmex/temas.png": 123,
	"./conversa/BannerConversa": 28,
	"./conversa/BannerConversa.png": 28,
	"./conversa/BannerConversaTolas": 29,
	"./conversa/BannerConversaTolas.png": 29,
	"./conversa/LogoIcoConversa": 30,
	"./conversa/LogoIcoConversa.png": 30,
	"./conversa/LogoSofia_": 31,
	"./conversa/LogoSofia_.png": 31,
	"./conversa/ico_conversa_close": 32,
	"./conversa/ico_conversa_close.png": 32,
	"./conversa/ico_conversa_float": 33,
	"./conversa/ico_conversa_float.png": 33,
	"./conversa/ico_sofia": 22,
	"./conversa/ico_sofia.png": 22,
	"./conversa/ico_sofia30": 19,
	"./conversa/ico_sofia30.png": 19,
	"./conversa/ico_sofia30.svg": 74,
	"./conversa/ico_sofia30_": 34,
	"./conversa/ico_sofia30_.png": 34,
	"./conversa/ico_sofia_close": 35,
	"./conversa/ico_sofia_close.png": 35,
	"./conversa/logoConversa": 36,
	"./conversa/logoConversa.png": 36,
	"./conversa/logoConversaIco": 37,
	"./conversa/logoConversaIco.png": 37,
	"./conversa/logo_Conversa_Color": 38,
	"./conversa/logo_Conversa_Color.png": 38,
	"./conversa/logo_Conversa_Color_Part": 39,
	"./conversa/logo_Conversa_Color_Part.png": 39,
	"./conversa/logo_sofia30_color": 40,
	"./conversa/logo_sofia30_color.png": 40,
	"./conversa/logo_sofia_color": 41,
	"./conversa/logo_sofia_color.webp": 41,
	"./cri/bghead": 124,
	"./cri/bghead.png": 124,
	"./cri/favicon.ico": 544,
	"./dom/bghead": 125,
	"./dom/bghead.png": 125,
	"./domenj/JuritecaBeta": 126,
	"./domenj/JuritecaBeta.jpg": 126,
	"./domenj/aecid": 127,
	"./domenj/aecid.png": 127,
	"./domenj/bghead": 128,
	"./domenj/bghead.png": 128,
	"./domenj/favicon.ico": 545,
	"./domenj/home": 129,
	"./domenj/home.png": 129,
	"./domenj/home_beta": 130,
	"./domenj/home_beta.png": 130,
	"./domenj/icoFacebook": 131,
	"./domenj/icoFacebook.svg": 131,
	"./domenj/icoInstagram": 132,
	"./domenj/icoInstagram.svg": 132,
	"./domenj/icoLinked": 133,
	"./domenj/icoLinked.svg": 133,
	"./domenj/icoX": 134,
	"./domenj/icoX.svg": 134,
	"./domenj/icoYoutube": 135,
	"./domenj/icoYoutube.svg": 135,
	"./domenj/img-nosotros-contacto": 136,
	"./domenj/img-nosotros-contacto.png": 136,
	"./domenj/img-nosotros-header": 137,
	"./domenj/img-nosotros-header.png": 137,
	"./domenj/img__Form__Suggets": 138,
	"./domenj/img__Form__Suggets.png": 138,
	"./domenj/logosPJRD-ENJ": 139,
	"./domenj/logosPJRD-ENJ.png": 139,
	"./domenj/pasos_juriteca": 140,
	"./domenj/pasos_juriteca.png": 140,
	"./ecu/bghead": 141,
	"./ecu/bghead.png": 141,
	"./ecu/favicon.ico": 546,
	"./flags/ca": 142,
	"./flags/ca.gif": 142,
	"./flags/en": 143,
	"./flags/en.gif": 143,
	"./flags/es": 144,
	"./flags/es.gif": 144,
	"./flags/eu": 145,
	"./flags/eu.gif": 145,
	"./flags/fr": 146,
	"./flags/fr.gif": 146,
	"./flags/gl": 147,
	"./flags/gl.gif": 147,
	"./flags/pt": 148,
	"./flags/pt.gif": 148,
	"./flags/va": 149,
	"./flags/va.gif": 149,
	"./gestor_notarial_bg": 150,
	"./gestor_notarial_bg.png": 150,
	"./gestor_notarial_ico": 151,
	"./gestor_notarial_ico.png": 151,
	"./gtm/bghead": 152,
	"./gtm/bghead.png": 152,
	"./head-anagrama": 153,
	"./head-anagrama.svg": 153,
	"./hnd/bghead": 154,
	"./hnd/bghead.png": 154,
	"./icoFacebook": 155,
	"./icoFacebook.svg": 155,
	"./icoRSS": 156,
	"./icoRSS.svg": 156,
	"./icoTwitter": 157,
	"./icoTwitter.svg": 157,
	"./img_Asistente_Documental": 158,
	"./img_Asistente_Documental.jpg": 158,
	"./img_Solicitud_Formularios": 159,
	"./img_Solicitud_Formularios.jpg": 159,
	"./jam/bghead": 160,
	"./jam/bghead.png": 160,
	"./latam/bghead": 161,
	"./latam/bghead.png": 161,
	"./legal-text": 162,
	"./legal-text.svg": 162,
	"./logo_tirant_wh": 163,
	"./logo_tirant_wh.svg": 163,
	"./materias/IcoArrendamientosUrbanos": 164,
	"./materias/IcoArrendamientosUrbanos.svg": 164,
	"./materias/IcoConcursal": 165,
	"./materias/IcoConcursal.svg": 165,
	"./materias/IcoContabilidad": 166,
	"./materias/IcoContabilidad.svg": 166,
	"./materias/IcoContratos": 167,
	"./materias/IcoContratos.svg": 167,
	"./materias/IcoDefault": 168,
	"./materias/IcoDefault.svg": 168,
	"./materias/IcoEjecucionPenal": 169,
	"./materias/IcoEjecucionPenal.svg": 169,
	"./materias/IcoExtranjeria": 170,
	"./materias/IcoExtranjeria.svg": 170,
	"./materias/IcoFamilia": 171,
	"./materias/IcoFamilia.svg": 171,
	"./materias/IcoFinanciero": 172,
	"./materias/IcoFinanciero.svg": 172,
	"./materias/IcoLaboral": 173,
	"./materias/IcoLaboral.svg": 173,
	"./materias/IcoMercantil": 174,
	"./materias/IcoMercantil.svg": 174,
	"./materias/IcoPenal": 175,
	"./materias/IcoPenal.svg": 175,
	"./materias/IcoPropiedadH": 176,
	"./materias/IcoPropiedadH.svg": 176,
	"./materias/IcoUrbanismo": 177,
	"./materias/IcoUrbanismo.svg": 177,
	"./nic/bghead": 178,
	"./nic/bghead.png": 178,
	"./pan/bghead": 179,
	"./pan/bghead.png": 179,
	"./per/bghead": 180,
	"./per/bghead.png": 180,
	"./per/favicon.ico": 547,
	"./prt/bghead": 181,
	"./prt/bghead.png": 181,
	"./pry/bghead": 182,
	"./pry/bghead.png": 182,
	"./slv/bghead": 183,
	"./slv/bghead.png": 183,
	"./slv/favicon.ico": 548,
	"./sofia/sofia-color": 184,
	"./sofia/sofia-color.png": 184,
	"./sofia/sofia-color_xl": 185,
	"./sofia/sofia-color_xl.png": 185,
	"./sofia/sofia-footer": 186,
	"./sofia/sofia-footer.png": 186,
	"./sofia/sofia-info-3d": 187,
	"./sofia/sofia-info-3d.png": 187,
	"./sofia/sofia-selection": 188,
	"./sofia/sofia-selection.png": 188,
	"./sofia/sofia_azul": 58,
	"./sofia/sofia_azul.png": 58,
	"./sort_asc": 189,
	"./sort_asc.png": 189,
	"./sort_asc_disabled": 190,
	"./sort_asc_disabled.png": 190,
	"./sort_both": 191,
	"./sort_both.png": 191,
	"./sort_desc": 192,
	"./sort_desc.png": 192,
	"./sort_desc_disabled": 193,
	"./sort_desc_disabled.png": 193,
	"./spinner": 194,
	"./spinner.gif": 194,
	"./spinner_colors": 195,
	"./spinner_colors.svg": 195,
	"./tase/bghead": 196,
	"./tase/bghead-old": 197,
	"./tase/bghead-old.png": 197,
	"./tase/bghead.png": 196,
	"./tase/external/icos/ico-actualidad": 198,
	"./tase/external/icos/ico-actualidad.svg": 198,
	"./tase/external/icos/ico-analytics": 199,
	"./tase/external/icos/ico-analytics.svg": 199,
	"./tase/external/icos/ico-asistente": 200,
	"./tase/external/icos/ico-asistente.svg": 200,
	"./tase/external/icos/ico-ayudas": 201,
	"./tase/external/icos/ico-ayudas.svg": 201,
	"./tase/external/icos/ico-back-actualidad": 202,
	"./tase/external/icos/ico-back-actualidad.svg": 202,
	"./tase/external/icos/ico-back-analytics": 203,
	"./tase/external/icos/ico-back-analytics.svg": 203,
	"./tase/external/icos/ico-back-asistente": 204,
	"./tase/external/icos/ico-back-asistente.svg": 204,
	"./tase/external/icos/ico-back-ayudas": 205,
	"./tase/external/icos/ico-back-ayudas.svg": 205,
	"./tase/external/icos/ico-back-base-de-datos": 206,
	"./tase/external/icos/ico-back-base-de-datos.svg": 206,
	"./tase/external/icos/ico-back-biblioteca-gps": 207,
	"./tase/external/icos/ico-back-biblioteca-gps.svg": 207,
	"./tase/external/icos/ico-back-biblioteca-t-conecta": 208,
	"./tase/external/icos/ico-back-biblioteca-t-conecta.svg": 208,
	"./tase/external/icos/ico-back-biblioteca-virtual": 209,
	"./tase/external/icos/ico-back-biblioteca-virtual.svg": 209,
	"./tase/external/icos/ico-back-calculadoras": 210,
	"./tase/external/icos/ico-back-calculadoras.svg": 210,
	"./tase/external/icos/ico-back-computo": 211,
	"./tase/external/icos/ico-back-computo.svg": 211,
	"./tase/external/icos/ico-back-consultoria": 212,
	"./tase/external/icos/ico-back-consultoria.svg": 212,
	"./tase/external/icos/ico-back-convenios": 213,
	"./tase/external/icos/ico-back-convenios.svg": 213,
	"./tase/external/icos/ico-back-db-latam": 214,
	"./tase/external/icos/ico-back-db-latam.svg": 214,
	"./tase/external/icos/ico-back-diario": 215,
	"./tase/external/icos/ico-back-diario.svg": 215,
	"./tase/external/icos/ico-back-dictado": 216,
	"./tase/external/icos/ico-back-dictado.svg": 216,
	"./tase/external/icos/ico-back-gestor-despachos": 217,
	"./tase/external/icos/ico-back-gestor-despachos.svg": 217,
	"./tase/external/icos/ico-back-legislacion": 218,
	"./tase/external/icos/ico-back-legislacion.svg": 218,
	"./tase/external/icos/ico-back-solicitud": 219,
	"./tase/external/icos/ico-back-solicitud.svg": 219,
	"./tase/external/icos/ico-back-traducciones": 220,
	"./tase/external/icos/ico-back-traducciones.svg": 220,
	"./tase/external/icos/ico-base-de-datos": 221,
	"./tase/external/icos/ico-base-de-datos.svg": 221,
	"./tase/external/icos/ico-biblioteca-gps": 222,
	"./tase/external/icos/ico-biblioteca-gps.svg": 222,
	"./tase/external/icos/ico-biblioteca-t-conecta": 223,
	"./tase/external/icos/ico-biblioteca-t-conecta.svg": 223,
	"./tase/external/icos/ico-biblioteca-virtual": 224,
	"./tase/external/icos/ico-biblioteca-virtual.svg": 224,
	"./tase/external/icos/ico-btn-up": 225,
	"./tase/external/icos/ico-btn-up.svg": 225,
	"./tase/external/icos/ico-calculadoras": 226,
	"./tase/external/icos/ico-calculadoras.svg": 226,
	"./tase/external/icos/ico-computo": 227,
	"./tase/external/icos/ico-computo.svg": 227,
	"./tase/external/icos/ico-consultoria": 228,
	"./tase/external/icos/ico-consultoria.svg": 228,
	"./tase/external/icos/ico-convenios": 229,
	"./tase/external/icos/ico-convenios.svg": 229,
	"./tase/external/icos/ico-db-latam": 230,
	"./tase/external/icos/ico-db-latam.svg": 230,
	"./tase/external/icos/ico-diario": 231,
	"./tase/external/icos/ico-diario.svg": 231,
	"./tase/external/icos/ico-dictado": 232,
	"./tase/external/icos/ico-dictado.svg": 232,
	"./tase/external/icos/ico-footer-facebook": 233,
	"./tase/external/icos/ico-footer-facebook.svg": 233,
	"./tase/external/icos/ico-footer-instragram": 234,
	"./tase/external/icos/ico-footer-instragram.svg": 234,
	"./tase/external/icos/ico-footer-linkedin": 235,
	"./tase/external/icos/ico-footer-linkedin.svg": 235,
	"./tase/external/icos/ico-footer-twitter": 236,
	"./tase/external/icos/ico-footer-twitter.svg": 236,
	"./tase/external/icos/ico-footer-youtube": 237,
	"./tase/external/icos/ico-footer-youtube.svg": 237,
	"./tase/external/icos/ico-gestor-despachos": 238,
	"./tase/external/icos/ico-gestor-despachos.svg": 238,
	"./tase/external/icos/ico-legislacion": 239,
	"./tase/external/icos/ico-legislacion.svg": 239,
	"./tase/external/icos/ico-llamada": 240,
	"./tase/external/icos/ico-llamada.svg": 240,
	"./tase/external/icos/ico-solicitud": 241,
	"./tase/external/icos/ico-solicitud.svg": 241,
	"./tase/external/icos/ico-traducciones": 242,
	"./tase/external/icos/ico-traducciones.svg": 242,
	"./tase/external/icos/ico-whatsapp": 243,
	"./tase/external/icos/ico-whatsapp.svg": 243,
	"./tase/external/img/bbGPS": 244,
	"./tase/external/img/bbGPS.svg": 244,
	"./tase/external/img/bg-aro-content": 245,
	"./tase/external/img/bg-aro-content.svg": 245,
	"./tase/external/img/btn-call": 246,
	"./tase/external/img/btn-call.svg": 246,
	"./tase/external/img/btn-plus": 247,
	"./tase/external/img/btn-plus-hover": 248,
	"./tase/external/img/btn-plus-hover.svg": 248,
	"./tase/external/img/btn-plus.svg": 247,
	"./tase/external/img/btn-whatsapp": 249,
	"./tase/external/img/btn-whatsapp.svg": 249,
	"./tase/external/img/header-compu-hero": 250,
	"./tase/external/img/header-compu-hero.svg": 250,
	"./tase/external/logos/logo-bbGP": 251,
	"./tase/external/logos/logo-bbGP.svg": 251,
	"./tase/external/logos/logo-conversa": 252,
	"./tase/external/logos/logo-conversa.svg": 252,
	"./tase/external/logos/logo-footer": 253,
	"./tase/external/logos/logo-footer.svg": 253,
	"./tase/external/logos/logo-header": 254,
	"./tase/external/logos/logo-header.svg": 254,
	"./tase/external/logos/logo-sofia": 255,
	"./tase/external/logos/logo-sofia-tase": 256,
	"./tase/external/logos/logo-sofia-tase.svg": 256,
	"./tase/external/logos/logo-sofia.svg": 255,
	"./tase/favicon.ico": 549,
	"./tase/icoImportant": 257,
	"./tase/icoImportant.webp": 257,
	"./tase/ico_biblioteca": 258,
	"./tase/ico_biblioteca.svg": 258,
	"./tase/ico_consultoria": 259,
	"./tase/ico_consultoria.svg": 259,
	"./timbres_honorarios_bg": 260,
	"./timbres_honorarios_bg.png": 260,
	"./timbres_honorarios_ico": 261,
	"./timbres_honorarios_ico.png": 261,
	"./tnr/bghead": 262,
	"./tnr/bghead-old": 263,
	"./tnr/bghead-old.png": 263,
	"./tnr/bghead.png": 262,
	"./tnr/ico_biblioteca": 264,
	"./tnr/ico_biblioteca.svg": 264,
	"./tnr/ico_consultoria": 265,
	"./tnr/ico_consultoria.svg": 265,
	"./tol/asistenciaporvoz": 266,
	"./tol/asistenciaporvoz.png": 266,
	"./tol/bghead": 267,
	"./tol/bghead-old": 268,
	"./tol/bghead-old.png": 268,
	"./tol/bghead.png": 267,
	"./tol/favicon.ico": 550,
	"./tol/ico_biblioteca": 269,
	"./tol/ico_biblioteca.svg": 269,
	"./tol/ico_consultoria": 270,
	"./tol/ico_consultoria.svg": 270,
	"./tolmex/bghead": 271,
	"./tolmex/bghead.png": 271,
	"./tolmex/favicon.ico": 551,
	"./tph/bghead": 272,
	"./tph/bghead-old": 273,
	"./tph/bghead-old.png": 273,
	"./tph/bghead.png": 272,
	"./tph/external/icos/btn-plus": 274,
	"./tph/external/icos/btn-plus.svg": 274,
	"./tph/external/icos/ico-actualidad": 275,
	"./tph/external/icos/ico-actualidad.svg": 275,
	"./tph/external/icos/ico-analytics": 276,
	"./tph/external/icos/ico-analytics.svg": 276,
	"./tph/external/icos/ico-asistente": 277,
	"./tph/external/icos/ico-asistente.svg": 277,
	"./tph/external/icos/ico-ayudas": 278,
	"./tph/external/icos/ico-ayudas.svg": 278,
	"./tph/external/icos/ico-back-actualidad": 279,
	"./tph/external/icos/ico-back-actualidad.svg": 279,
	"./tph/external/icos/ico-back-analytics": 280,
	"./tph/external/icos/ico-back-analytics.svg": 280,
	"./tph/external/icos/ico-back-asistente": 281,
	"./tph/external/icos/ico-back-asistente.svg": 281,
	"./tph/external/icos/ico-back-ayudas": 282,
	"./tph/external/icos/ico-back-ayudas.svg": 282,
	"./tph/external/icos/ico-back-base-de-datos": 283,
	"./tph/external/icos/ico-back-base-de-datos.svg": 283,
	"./tph/external/icos/ico-back-biblioteca-gps": 284,
	"./tph/external/icos/ico-back-biblioteca-gps.svg": 284,
	"./tph/external/icos/ico-back-biblioteca-t-conecta": 285,
	"./tph/external/icos/ico-back-biblioteca-t-conecta.svg": 285,
	"./tph/external/icos/ico-back-biblioteca-virtual": 286,
	"./tph/external/icos/ico-back-biblioteca-virtual.svg": 286,
	"./tph/external/icos/ico-back-calculadoras": 287,
	"./tph/external/icos/ico-back-calculadoras.svg": 287,
	"./tph/external/icos/ico-back-computo": 288,
	"./tph/external/icos/ico-back-computo.svg": 288,
	"./tph/external/icos/ico-back-consultoria": 289,
	"./tph/external/icos/ico-back-consultoria.svg": 289,
	"./tph/external/icos/ico-back-convenios": 290,
	"./tph/external/icos/ico-back-convenios.svg": 290,
	"./tph/external/icos/ico-back-db-latam": 291,
	"./tph/external/icos/ico-back-db-latam.svg": 291,
	"./tph/external/icos/ico-back-diario": 292,
	"./tph/external/icos/ico-back-diario.svg": 292,
	"./tph/external/icos/ico-back-dictado": 293,
	"./tph/external/icos/ico-back-dictado.svg": 293,
	"./tph/external/icos/ico-back-especialidades": 294,
	"./tph/external/icos/ico-back-especialidades.svg": 294,
	"./tph/external/icos/ico-back-gestor_despachos": 295,
	"./tph/external/icos/ico-back-gestor_despachos.svg": 295,
	"./tph/external/icos/ico-back-legislacion": 296,
	"./tph/external/icos/ico-back-legislacion.svg": 296,
	"./tph/external/icos/ico-back-solicitud": 297,
	"./tph/external/icos/ico-back-solicitud.svg": 297,
	"./tph/external/icos/ico-back-traducciones": 298,
	"./tph/external/icos/ico-back-traducciones.svg": 298,
	"./tph/external/icos/ico-base-de-datos": 299,
	"./tph/external/icos/ico-base-de-datos.svg": 299,
	"./tph/external/icos/ico-biblioteca-gps": 300,
	"./tph/external/icos/ico-biblioteca-gps.svg": 300,
	"./tph/external/icos/ico-biblioteca-t-conecta": 301,
	"./tph/external/icos/ico-biblioteca-t-conecta.svg": 301,
	"./tph/external/icos/ico-biblioteca-virtual": 302,
	"./tph/external/icos/ico-biblioteca-virtual.svg": 302,
	"./tph/external/icos/ico-btn-up": 303,
	"./tph/external/icos/ico-btn-up.svg": 303,
	"./tph/external/icos/ico-calculadoras": 304,
	"./tph/external/icos/ico-calculadoras.svg": 304,
	"./tph/external/icos/ico-computo": 305,
	"./tph/external/icos/ico-computo.svg": 305,
	"./tph/external/icos/ico-consultoria": 306,
	"./tph/external/icos/ico-consultoria.svg": 306,
	"./tph/external/icos/ico-convenios": 307,
	"./tph/external/icos/ico-convenios.svg": 307,
	"./tph/external/icos/ico-db-latam": 308,
	"./tph/external/icos/ico-db-latam.svg": 308,
	"./tph/external/icos/ico-diario": 309,
	"./tph/external/icos/ico-diario.svg": 309,
	"./tph/external/icos/ico-dictado": 310,
	"./tph/external/icos/ico-dictado.svg": 310,
	"./tph/external/icos/ico-especialidades": 311,
	"./tph/external/icos/ico-especialidades.svg": 311,
	"./tph/external/icos/ico-footer-facebook": 312,
	"./tph/external/icos/ico-footer-facebook.svg": 312,
	"./tph/external/icos/ico-footer-instragram": 313,
	"./tph/external/icos/ico-footer-instragram.svg": 313,
	"./tph/external/icos/ico-footer-linkedin": 314,
	"./tph/external/icos/ico-footer-linkedin.svg": 314,
	"./tph/external/icos/ico-footer-twitter": 315,
	"./tph/external/icos/ico-footer-twitter.svg": 315,
	"./tph/external/icos/ico-footer-youtube": 316,
	"./tph/external/icos/ico-footer-youtube.svg": 316,
	"./tph/external/icos/ico-gestor_despachos": 317,
	"./tph/external/icos/ico-gestor_despachos.svg": 317,
	"./tph/external/icos/ico-legislacion": 318,
	"./tph/external/icos/ico-legislacion.svg": 318,
	"./tph/external/icos/ico-llamada": 319,
	"./tph/external/icos/ico-llamada.svg": 319,
	"./tph/external/icos/ico-solicitud": 320,
	"./tph/external/icos/ico-solicitud.svg": 320,
	"./tph/external/icos/ico-traducciones": 321,
	"./tph/external/icos/ico-traducciones.svg": 321,
	"./tph/external/icos/ico-whatsapp": 322,
	"./tph/external/icos/ico-whatsapp.svg": 322,
	"./tph/external/img/bg-aro-content": 323,
	"./tph/external/img/bg-aro-content.svg": 323,
	"./tph/external/img/btn-call": 324,
	"./tph/external/img/btn-call.svg": 324,
	"./tph/external/img/btn-plus": 325,
	"./tph/external/img/btn-plus.svg": 325,
	"./tph/external/img/btn-whatsapp": 326,
	"./tph/external/img/btn-whatsapp.svg": 326,
	"./tph/external/img/header-compu-hero": 59,
	"./tph/external/img/header-compu-hero.png": 59,
	"./tph/external/img/header-compu-hero.svg": 552,
	"./tph/external/logos/logo-conversa": 327,
	"./tph/external/logos/logo-conversa.svg": 327,
	"./tph/external/logos/logo-footer": 328,
	"./tph/external/logos/logo-footer.svg": 328,
	"./tph/external/logos/logo-header": 329,
	"./tph/external/logos/logo-header.svg": 329,
	"./tph/external/logos/logo-sofia": 330,
	"./tph/external/logos/logo-sofia-tph": 331,
	"./tph/external/logos/logo-sofia-tph.svg": 331,
	"./tph/external/logos/logo-sofia.svg": 330,
	"./tph/favicon.ico": 553,
	"./tph/icoImportant": 60,
	"./tph/icoImportant.svg": 60,
	"./tph/icoImportant.webp": 554,
	"./tph/ico_biblioteca": 332,
	"./tph/ico_biblioteca.svg": 332,
	"./tph/ico_consultoria": 333,
	"./tph/ico_consultoria.svg": 333,
	"./tto/bghead": 334,
	"./tto/bghead.png": 334,
	"./ury/bghead": 335,
	"./ury/bghead.png": 335,
	"./ven/bghead": 336,
	"./ven/bghead.png": 336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;